export default class SimpleClass {
  constructor() {
    this.debug = false;

    this.state = {};

    this.debounce = 50;

    this.performance = {
      init: new Date().getTime(),
      start: null,
      end: null,
      result: null,
    };
  }

  log() {
    // this.debug && console.log(message);
  }

  setState(key, value) {
    const log = {
      prevState: this.state,
    };
    this.state = { ...this.state, [key]: value };
    log.nextState = this.state;
    this.log(log);
    return this.state;
  }

  startTimer() {
    this.performance.start = new Date().getTime();
  }

  sendEvent(
    name,
    options = { target: document, logMessage: null, detail: null },
    eventOptions = { bubbles: true, cancelable: false }
  ) {
    if (this.debug && options.logMessage) {
      this.log(options.logMessage);
    }

    options.target.dispatchEvent(
      new CustomEvent(name, {
        ...eventOptions,
        detail: options.detail,
      })
    );
  }

  stopTimer() {
    this.performance.end = new Date().getTime();
    this.performance.result = this.performance.end - this.performance.start;

    if (this.debug) {
      this.log(`init took: ${this.performance.result} ms`);
    }
  }

  addDebouncedEventListener(target, type, listener, options = {}, debounce = this.debounce) {
    let timeout;
    target.addEventListener(
      type,
      () => {
        if (timeout) clearTimeout(timeout);
        timeout = setTimeout(() => listener, debounce);
      },
      options
    );
  }

  setLocalStorageValue(key, value) {
    const { localStorage } = window;
    localStorage.setItem(key, value);
    return {
      key: value,
    };
  }

  getLocalStorageValue(key) {
    const { localStorage } = window;
    return localStorage.getItem(key);
  }

  setSessionStorageValue(key, value) {
    const { sessionStorage } = window;
    sessionStorage.setItem(key, value);
    return {
      key: value,
    };
  }

  getSessionStorageValue(key) {
    const { sessionStorage } = window;
    return sessionStorage.getItem(key);
  }
}
